import * as React from "react";
import {
  InputElementUnion,
  IPostalCodeInputElement,
  ISectionElement,
  isInputElement,
  isTextInputElement,
  ITextInputElement,
} from "@graffer-inc/form-schema";
import { CommonPropertiesEditor } from "../common-properties-editor";
import { useMemo } from "react";

type PostalCodeInputEditorProps = {
  element: IPostalCodeInputElement;
  onElementUpdate: (arg: InputElementUnion) => void;
  sections: ISectionElement[];
};

export const PostalCodeInputEditor: React.FC<PostalCodeInputEditorProps> = ({
  element,
  onElementUpdate,
  sections,
}) => {
  const postalCode = `${element.id}-postalCode`;

  const sectionOptions = useMemo(() => {
    const currentSection = sections.find((section) =>
      section.children.some((child) => child.id === element.id),
    );
    if (!currentSection) {
      return [];
    }
    const elementIndex = currentSection.children.findIndex(
      (child) => child.id === element.id,
    );
    return currentSection.children.reduce<ITextInputElement[]>(
      (acc, elem, index) =>
        isInputElement(elem) &&
        isTextInputElement(elem) &&
        (element.addressCompleteTarget === elem.id || elementIndex < index)
          ? [...acc, elem]
          : acc,
      [],
    );
  }, [sections, element]);

  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      <hr />
      <div className="field">
        <label className="label" htmlFor={postalCode}>
          適用する項目
        </label>
        <div className="control">
          <p>
            {
              sectionOptions.find(
                (elem) => elem.id === element.addressCompleteTarget,
              )?.label.text
            }
          </p>
        </div>
      </div>
    </>
  );
};
